export default __webpack_public_path__ + "static/media/26.5425709a.jpeg";